import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { FaFileImage, FaSlidersH, FaSuitcaseRolling, FaInbox, FaChevronRight } from "react-icons/fa";
import { Link } from 'react-router-dom';

function Home() {
    const dispatch = useDispatch();
    const Data = useSelector((state) => state.contactus);
    const dashboardData = Data.data || {};
    const table_counts = dashboardData.table_counts || {};

    useEffect(() => {
        dispatch(getDashboardData());
    }, [dispatch]);

    const stats = [
        {
            title: 'Tour Packages',
            count: table_counts?.khajuraho_packages || 0,
            icon: <FaSuitcaseRolling size={28} />,
            color: 'var(--primary-gold)', 
            link: '/khajuraho/packages'
        },
        {
            title: 'Inbound Enquiries',
            count: table_counts?.khajuraho_enquiries || 0,
            icon: <FaInbox size={28} />,
            color: 'var(--primary-gold)', 
            link: '/khajuraho/enquiries'
        },
        {
            title: 'Gallery Assets',
            count: table_counts?.khajuraho_gallery || 0,
            icon: <FaFileImage size={28} />,
            color: 'var(--primary-gold)', 
            link: '/khajuraho/gallery'
        },
        {
            title: 'Active Banners',
            count: table_counts?.khajuraho_banner || 0,
            icon: <FaSlidersH size={28} />,
            color: 'var(--primary-gold)', 
            link: '/khajuraho/banners'
        }
    ];

    return (
        <div className="container-fluid pb-5 px-4 fade-in">
            {/* Header Section Removed */}

            {/* Stats Grid */}
            <div className="row">
                {stats.map((stat, index) => (
                    <div key={index} className="col-xl-3 col-md-6 mb-4">
                        <div className="card border-0 h-100 p-4">
                            <div className="d-flex justify-content-between align-items-start mb-4">
                                <div className="stat-icon-box" style={{ backgroundColor: `${stat.color}15`, color: stat.color }}>
                                    {stat.icon}
                                </div>
                            </div>
                            <h2 className="font-weight-bold mb-1" style={{ fontSize: '2.8rem', color: '#1a1a1a' }}>{stat.count}</h2>
                            <p className="text-muted mb-4 font-weight-medium" style={{ letterSpacing: '0.5px' }}>{stat.title}</p>
                            <Link to={stat.link} className="btn btn-link p-0 text-decoration-none font-weight-bold d-flex align-items-center transition" style={{ color: 'var(--primary-gold)', fontSize: '0.9rem' }}>
                                View Full Report <FaChevronRight className="ml-2" size={12} />
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            {/* Quick Actions & Overview */}
            <div className="row mt-5">
                <div className="col-lg-8 mb-4">
                    <div className="card border-0 p-5 h-100 shadow-sm" style={{ borderRadius: '20px' }}>
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <div>
                                <h4 className="font-weight-bold mb-1" style={{ color: '#1a1a1a' }}>Dashboard Overview</h4>
                                <p className="small text-muted mb-0">Manage Khajuraho Routes effectively</p>
                            </div>
                            <div className="d-flex align-items-center bg-light rounded-pill px-3 py-2">
                                <span className="p-2 rounded-circle bg-success mr-2" style={{ width: '8px', height: '8px', boxShadow: '0 0 10px #28a745' }}></span>
                                <span className="small font-weight-bold text-dark">LIVE</span>
                            </div>
                        </div>
                        
                        <div className="row mt-4">
                            <div className="col-md-6 mb-3">
                                <div className="p-4 rounded-xl" style={{ backgroundColor: '#fff4e6', border: '1px solid #ffd8a8' }}>
                                    <h6 className="font-weight-bold text-dark mb-2">Package Management</h6>
                                    <p className="text-muted small mb-3">You have {table_counts?.khajuraho_packages || 0} active packages. Keep them updated to attract more tourists.</p>
                                    <Link to="/khajuraho/packages" className="btn btn-sm btn-dark" style={{ backgroundColor: 'var(--primary-gold)', border: 'none' }}>Go to Packages</Link>
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <div className="p-4 rounded-xl" style={{ backgroundColor: '#e6fcf5', border: '1px solid #b2f2bb' }}>
                                    <h6 className="font-weight-bold text-dark mb-2">Customer Enquiries</h6>
                                    <p className="text-muted small mb-3">{table_counts?.khajuraho_enquiries || 0} enquiries received. Respond promptly to increase conversions.</p>
                                    <Link to="/khajuraho/enquiries" className="btn btn-sm btn-dark" style={{ backgroundColor: '#20c997', border: 'none' }}>View Enquiries</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <div className="card border-0 p-5 h-100 shadow-sm" style={{ background: '#1e1e2f', color: '#fff', borderRadius: '20px' }}>
                        <h4 className="font-weight-bold mb-4" style={{ color: 'var(--primary-gold)' }}>Quick Actions</h4>
                        <div className="d-flex flex-column gap-3">
                            <Link to="/khajuraho/packages/add" className="text-decoration-none">
                                <div className="quick-action-item d-flex align-items-center p-3 rounded-xl transition" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                                    <div className="mr-3 p-2 bg-white rounded-lg shadow-sm d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', color: 'var(--primary-gold)' }}>
                                        <FaSuitcaseRolling />
                                    </div>
                                    <div>
                                        <p className="mb-0 font-weight-bold small text-white">Add New Package</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/khajuraho/gallery" className="text-decoration-none">
                                <div className="quick-action-item d-flex align-items-center p-3 rounded-xl transition" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                                    <div className="mr-3 p-2 bg-white rounded-lg shadow-sm d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', color: 'var(--primary-gold)' }}>
                                        <FaFileImage />
                                    </div>
                                    <div>
                                        <p className="mb-0 font-weight-bold small text-white">Upload Gallery Image</p>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/khajuraho/banners" className="text-decoration-none">
                                <div className="quick-action-item d-flex align-items-center p-3 rounded-xl transition" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                                    <div className="mr-3 p-2 bg-white rounded-lg shadow-sm d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', color: 'var(--primary-gold)' }}>
                                        <FaSlidersH />
                                    </div>
                                    <div>
                                        <p className="mb-0 font-weight-bold small text-white">Manage Banners</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
